import Cookies from "js-cookie";
import {
  GeorgiaIcon,
  RussiaIcon,
  UkraineIcon,
  UsaIcon,
  UzbekistanIcon,
} from "@/components/assets/icons";
import { InterfaceLanguage, Theme, ThemeCountry } from "@/enums";
import { isEmptyValue } from "./isEmptyValue";

const DOMAIN_LANGUAGES: {
  [key in ThemeCountry]: InterfaceLanguage[];
} = {
  [ThemeCountry.UZ]: [
    InterfaceLanguage.UZ,
    InterfaceLanguage.EN,
    InterfaceLanguage.RU,
  ],
  [ThemeCountry.GEORGIA]: [
    InterfaceLanguage.KA,
    InterfaceLanguage.EN,
    InterfaceLanguage.RU,
  ],
  [ThemeCountry.UK]: [
    InterfaceLanguage.UK,
    InterfaceLanguage.EN,
    InterfaceLanguage.RU,
  ],
};

export const getLanguagesList = (theme: Theme) => {
  return [
    {
      name: InterfaceLanguage.KA,
      icon: GeorgiaIcon,
      show: theme === Theme.GEORGIA,
    },
    {
      name: InterfaceLanguage.RU,
      icon: RussiaIcon,
      show: theme !== Theme.UK,
    },
    {
      name: InterfaceLanguage.UK,
      icon: UkraineIcon,
      show: theme === Theme.UK,
    },
    {
      name: InterfaceLanguage.EN,
      icon: UsaIcon,
      show: true,
    },
    {
      name: InterfaceLanguage.UZ,
      icon: UzbekistanIcon,
      show: theme === Theme.UZ,
    },
  ];
};

const getDefaultLanguageForDomain = (theme: Theme) => {
  const themeLang: ThemeCountry = getThemeLangKey(theme);
  return DOMAIN_LANGUAGES[themeLang]?.[0];
};

const getThemeLangKey = (theme: Theme) => {
  switch (theme) {
    case Theme.UZ:
      return ThemeCountry.UZ;
    case Theme.GEORGIA:
      return ThemeCountry.GEORGIA;
    case Theme.UK:
      return ThemeCountry.UK;
    default:
      break;
  }
};

const isLanguageAllowedForDomain = (theme: Theme, lang: InterfaceLanguage) => {
  const themeLang: ThemeCountry = getThemeLangKey(theme);
  return DOMAIN_LANGUAGES[themeLang]?.includes(lang) || false;
};

export const initializeLanguage = (
  isLoading: boolean,
  theme: Theme,
  data: any,
  isExternalPage: boolean,
  setLang: React.Dispatch<React.SetStateAction<InterfaceLanguage | undefined>>,
) => {
  if (typeof window !== "undefined") {
    const defaultLang = getDefaultLanguageForDomain(theme as Theme);
    const cookieLocale: InterfaceLanguage | undefined =
      (Cookies.get("locale") as InterfaceLanguage) || defaultLang;

    if (!isLoading) {
      const newLang =
        !isExternalPage && !isEmptyValue(data?.data?.data?.lang)
          ? data?.data?.data?.lang
          : cookieLocale;

      const allowedLang = isLanguageAllowedForDomain(theme, newLang)
        ? newLang
        : defaultLang;

      setLang(allowedLang);
      if (!cookieLocale || newLang !== cookieLocale) {
        Cookies.set("locale", newLang, { path: "/" });
        window.location.reload();
      }
    }
  }
};
